module.exports = __webpack_public_path__ + "static/media/oktober.3cdc122b.png";